import { exportBankReconciliation } from "@api/accountingReports.api";
import { saveBlobResponse, useFileDownload } from "@lib/fileDownload";
import { useScope } from "@state/scopeContext.lib";

export function useBankReconciliationReportDownload(
    bankReconciliationId: string | undefined,
) {
    const { workspaceId } = useScope();

    return useFileDownload(async () => {
        if (!bankReconciliationId || !workspaceId) {
            return;
        }

        const response = await exportBankReconciliation({
            bankReconciliationId,
            workspaceId,
        });

        saveBlobResponse(response, "Bank Reconciliation Report.pdf");
    });
}
